import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import { DistratoForm } from "../modais"
class DistratosCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/distratos")
  }
  render() {
    return (
      <Layout tabActive="Distratos">
        <DistratoForm callBack={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(DistratosCreateForm)



// WEBPACK FOOTER //
// ./src/views/distratos/DistratosCreateForm.js